/* eslint-disable react/require-default-props */
import {
  SelectHTMLAttributes,
  forwardRef,
  useRef,
  useState,
  useCallback,
  ForwardedRef,
  useImperativeHandle,
  CSSProperties,
} from 'react';

import { IoIosArrowDown } from 'react-icons/io';

import * as S from './styles';

export interface SelectOptionProps {
  label?: string;
  value?: string | number;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  options?: SelectOptionProps[];
  fieldLabel?: string;
  value?: string;
  containerStyle?: CSSProperties;
  initialValue?: SelectOptionProps;
  isDisabled?: boolean;
  setParentFocus?: () => void;
}

const DefaultSelect = forwardRef(
  (
    {
      name,
      options,
      setParentFocus,
      containerStyle = {},
      fieldLabel,
      initialValue,
      isDisabled = false,
      ...props
    }: SelectProps,
    innerRef?: ForwardedRef<HTMLSelectElement>,
  ) => {
    const [isFocused, setIsFocused] = useState(false);

    const inputRef = useRef<HTMLSelectElement>(null);

    useImperativeHandle<HTMLSelectElement | null, HTMLSelectElement | null>(
      innerRef,
      () => inputRef.current,
      [],
    );

    const handleInputFocus = useCallback((): void => {
      setIsFocused(true);
      if (setParentFocus) {
        setParentFocus();
      }
    }, [setParentFocus]);

    const handleInputBlur = useCallback(() => {
      setIsFocused(false);
    }, []);

    return (
      <S.SelectWrapper>
        {fieldLabel && <S.Label htmlFor={name}>{fieldLabel}</S.Label>}
        <S.SelectBlock
          isErrored={false}
          isFocused={isFocused}
          isDisabled={isDisabled}
          style={containerStyle}
        >
          <S.SelectField
            name={name}
            ref={inputRef}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            isFocused={isFocused}
            {...props}
          >
            <option value={initialValue?.value || ''}>
              {initialValue?.label || 'Selecione uma opção'}
            </option>
            {options
              ?.filter((option) => option.value !== initialValue?.value)
              .map((option) => (
                <option key={option.value || ''} value={option.value || ''}>
                  {option.label}
                </option>
              ))}
          </S.SelectField>
          <IoIosArrowDown
            size={20}
            style={{ position: 'absolute', right: 10, zIndex: -1 }}
          />
        </S.SelectBlock>
      </S.SelectWrapper>
    );
  },
);

export default DefaultSelect;
